import { Card, Flex, Text, Title } from '@mantine/core'
import React from 'react'

import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'

import { OrganizationSelector } from '../components/OrganizationSelector/OrganizationSelector.component'
import { useChangeOrganizationProcess } from '../hooks/useChangeOrganizationProcess.hook'
import styles from './SelectOrganization.view.module.scss'

const SelectOrganizationView: React.FC = () => {
  const { handleChangeOrganization, isChanging, error } =
    useChangeOrganizationProcess()

  return (
    <>
      <Flex>
        <Card shadow="lg" radius="md" withBorder className={styles.card}>
          <>
            <Title order={3} className={styles.title}>
              Select your organization
            </Title>
            <Text size="sm" c="dimmed" className={styles.description}>
              Choose an organization to continue
            </Text>

            <OrganizationSelector
              onChange={handleChangeOrganization}
              disabled={isChanging}
            />

            {error && (
              <Text c="red" size="sm" mt="md">
                {error}
              </Text>
            )}
          </>
        </Card>
      </Flex>
    </>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  SelectOrganizationView,
  'is_enable_select_organization',
  true,
)
